import React, { PropTypes } from 'react';
import classnames from 'classnames';

export default class GalleryArrowRight extends React.Component {
  static propTypes = {
    currentSlide: PropTypes.number,
    slidesToScroll: PropTypes.number,
    slidesToShow: PropTypes.number,
    slideCount: PropTypes.number,
    nextSlide: PropTypes.func,
  };

  render() {
    const { currentSlide, slidesToScroll, slidesToShow, slideCount, nextSlide } = this.props;

    const styles = {
      wrapper: classnames({
        'gallery--arrow': true,
        'gallery--arrow-right': true,
        'gallery--arrow--disabled': currentSlide + slidesToScroll + slidesToShow - 1 >= slideCount,
      }),
    };

    return (
      <div className={styles.wrapper} onClick={nextSlide} />
    );
  }
}



/** WEBPACK FOOTER **
 ** ./web/js/components/Gallery/GalleryArrowRight.jsx
 **/